/* eslint-disable sort-keys */
import { useTranslate } from '@im/react-localization';
import { usePageTitle } from 'mf_core/config';
import { useEffect } from 'react';

// To add a page title on a framed route, map translation keys to frame urls here:
const frameTitleMap: { [search: string]: string } = {
  '?url=%2FSite%2FMyProfile': 'Title.MyAccount',
  '?url=%2FSite%2FMyProfile%2FBrandingPreferences': 'Title.MyAccount',
  '?url=%2FSite%2FMyProfile%2FMyProfileAddress': 'Title.MyAccount',
  '?url=%2FSite%2FMyProfile%2FNotificationPreferences': 'Title.MyAccount',
  '?url=%2FSite%2FMyProfile%2FReportPreferences': 'Title.MyAccount',
  '?url=%2FSite%2FUserAdministration': 'Title.MyAccount',
  '?url=%2FSite%2FMfa%2FTwoFactorAuthentication': 'Title.MyAccount',

  '?url=%2Fspa%2Fostordersearchcep%2F%23%2Forders': 'Title.Orders',

  '?url=%2Fspa%2Fdommsoftware%2F%23%2Fsearch-result': 'Title.Renewals',

  '?url=%2Fspa%2Fpcbidpricingcep%2F%23%2Fcisco%2Fdealdetails':
    'Title.DealDetails',
  '?url=%2Fspa%2Fpcquoteoptionscep%2F%23%2Fdell%2Frequestquote':
    'RequestQuote.RequestQuote',
  '?url=%2Fspa%2Fpcbidpricingcep%2Findex.html': 'Title.DealDetails',
  '?url=%2Fspa%2Fdomqdetailscep%2F%23%2Fquotedetails':
    'QuoteDetails.QuoteDetails',

  '?url=%2FSite%2FReturns': 'Title.ReturnsAndClaims',
  '?url=%2FSite%2FReturns%2FClaims': 'Title.ReturnsAndClaims',
  '?url=%2FSite%2FReturns%2FStartReturn': 'Title.ReturnsAndClaims',
  '?url=%2FSite%2FReturns%2FReturnClaims': 'Title.ReturnsAndClaims',
  '?url=%2FSite%2FLogin%2FIdpWidget%3FReturnUrl%3D%252FSite%252FReturns':
    'Title.ReturnsAndClaims',
};

const DEFAULT_PAGE_TITLE = 'Xvantage';

type FrameTitleProps = {
  url: string;
};

export function FramedPageTitle(props: FrameTitleProps) {
  const { url } = props;
  const translate = useTranslate();
  const { updatePageTitle } = usePageTitle();

  const pageTitle = frameTitleMap[url]
    ? translate(frameTitleMap[url])
    : DEFAULT_PAGE_TITLE;

  useEffect(() => {
    if (frameTitleMap[url]) {
      updatePageTitle(pageTitle);
    }
  }, [pageTitle, updatePageTitle, url]);

  return null;
}
